import React, { Key, useEffect, useState } from 'react'
import './LeaveAdmin.scss'
import { Link } from 'react-router-dom'
import { Logger } from '../../../../../Helpers/Logger'
import productService from '../../../../../Services/productService'
import { ProductType } from '../../../../../Models'
import { HorizontalLoader, ModalWrapper } from '../../../../../Components'
import Pagination from '../../../../../Components/Pagination/Pagination'
import { DateConverterWord, IsOneYearOrMore, TableSerialNumber } from 'Helpers'
import { LeaveForm } from './LeaveForm'
import { leaveService } from '../../../../../Services/leaveService'
import { leaveType } from '../../../../../Models/leaveType'
import Swal from 'sweetalert2'
import { useSelector } from 'react-redux'
import { useAuth } from 'Components/AuthProvider/AuthProvider'
import { useEmployeeProfile } from 'Context/ProfileContext'
import { DownloadSvg, FilterSvg, SearchSvgMuted } from 'Components/Svgs'
import { useForm } from 'react-hook-form'

const LeaveAdmin = () => {
  const [loading, setLoading] = useState(false)

  const role = useSelector((state: any) => state.role)
  const { user } = useAuth()
  const isHr = role === 'hr' || user?.role === 'hr' ? true : false

  const { profile } = useEmployeeProfile()

  const isEmployeeExactlyAYearOrMoreThanAYear = IsOneYearOrMore(profile?.employmentDate)

  const [paginationData, setPaginationData] = useState<{
    pageNumber: number
    pageSize: number
    total: number
  }>({
    pageNumber: 1,
    pageSize: 20,
    total: 1,
  })

  const [request, setRequest] = useState(false)
  const [pageNumber, setPageNumber] = useState(1)
  const [leave, setLeave] = useState<leaveType[]>()

  const { register, watch } = useForm()
  const [sortOrder, setSortOrder] = useState('DESC')
  const [status, setStatus] = useState<string | undefined>(undefined)
  const [hrApprovalStatus, setHrApprovalStatus] = useState<string | undefined>(undefined)

  const handleReset = (e: any) => {
    e.preventDefault()
    setStatus(undefined)
    setHrApprovalStatus(undefined)
  }
  const empty = status || hrApprovalStatus

  const name = watch('name')
  const leaveDateFrom = watch('leaveDateFrom')
  const leaveDateTo = watch('leaveDateTo')
  const [debouncedEmployeeName, setDebouncedEmployeeName] = useState('')

  const buildSearchParams = (value?: string) => {
    if (!value) return {}
    const trimmed = value.trim()

    if (trimmed.startsWith('EMP_')) {
      return { userId: trimmed }
    }
    if (/^\d+$/.test(trimmed)) {
      return { id: trimmed }
    }
    if (/^[a-zA-Z0-9]+$/.test(trimmed) && trimmed.length > 15) {
      return { id: trimmed }
    }

    return { employeeName: trimmed }
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedEmployeeName(name || '')
    }, 500)

    return () => clearTimeout(timeout)
  }, [name])

  const getLeave = async () => {
    setRequest(true)
    await leaveService.getAdminLeave(pageNumber, sortOrder, status, hrApprovalStatus, debouncedEmployeeName).then(
      (data) => {
        // console.log('r', data.data.data.dataset)
        setLeave(data.data.data.dataset)
        setRequest(false)

        setPaginationData({
          pageNumber: data?.data.data.pageNumber,
          pageSize: data?.data.data.pageSize,
          total: data?.data.data.total,
        })
      },
      (error: { response: { data: { error: string } } }) => {
        // console.log('leaveService', error)
        setRequest(false)
        Swal.fire({
          icon: 'warning',
          title: 'Oops!',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 3000,
        })
      },
    )
  }

  useEffect(() => {
    getLeave()
  }, [pageNumber, sortOrder, status, hrApprovalStatus, debouncedEmployeeName])

  const [showModal, setShowModal] = useState(false)

  const toggleModal = () => {
    setShowModal((prevState) => !prevState)
  }

  const leaveAction = async (leaveId: string, action: string) => {
    Swal.fire({
      title: 'Alert?',
      text: `Are you sure you want to ${action} this leave?`,
      showDenyButton: true,
      confirmButtonText: 'Yes',
      denyButtonText: 'No',
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        Swal.showLoading()
        await leaveService.leaveAction(leaveId, action, isHr).then(
          () => {
            getLeave()
            Swal.fire({
              icon: 'success',
              title: 'Done!',
              text: `Leave ${action === 'approve' ? 'approved' : 'rejected'} succesfully!`,
              showConfirmButton: false,
              timer: 3000,
            })
            Swal.hideLoading()
          },
          (error: { response: { data: { error: string } } }) => {
            Swal.hideLoading()
            console.log('leaveService', error)
            setRequest(false)
            Swal.fire({
              icon: 'warning',
              title: 'Oops!',
              text: error.response.data.error,
              showConfirmButton: false,
              timer: 3000,
            })
          },
        )
      }
    })
  }

  function formatString(str: string) {
    return (
      str
        // Split the string by underscores
        .split('_')
        // Capitalize the first letter of each word
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        // Join the words back with a space
        .join(' ')
    )
  }

  // const filteredLeave = (leave ?? []).filter((item) => {
  //   const employeeFullName =
  //     `${item.employee?.firstName ?? ''} ${item.employee?.lastName ?? ''}`.toLowerCase()

  //   const employeeMatches =
  //     !employeeName?.trim() || employeeFullName.includes(employeeName.trim().toLowerCase())

  //   const dateMatches =
  //     (!leaveDateFrom && !leaveDateTo) ||
  //     ((!leaveDateFrom || item.endDate >= leaveDateFrom) &&
  //       (!leaveDateTo || item.startDate <= leaveDateTo))

  //   return employeeMatches && dateMatches
  // })
  return (
    <div className='LeaveAdmin'>
      <div className='container mt-4'>
        <div className='container'>
          <div className='card border-0'>
            <div className='card-header border-0 px-0'>
              <div className='row'>
                <div className='col-6 col-md-6 my-auto'>
                  <div className='title'>{paginationData.total} total leave applications</div>
                </div>
                <div className='col-6 col-md-6 text-end d-none'>
                  <button className='btn btn-add-company' onClick={toggleModal}>
                    Add New Leave
                  </button>
                </div>
              </div>

              <div className='row mt-2'>
                <div className='col-12 col-md-8'>
                  <div className='search-field'>
                    <span>
                      <SearchSvgMuted />
                    </span>

                    <input
                      type='text'
                      className='form-control'
                      placeholder='Search by Name'
                      {...register('name')}
                    />
                  </div>
                </div>
                <div className='col-6 col-md-2 dropdown'>
                  <button
                    className='btn btn-filter dropdown-toggle'
                    data-bs-toggle='dropdown'
                    aria-expanded='false'
                  >
                    <FilterSvg />
                    Filters
                  </button>
                  <div className='dropdown-menu dropdown-menu-end border-0 shadow filter-dropdown'>
                    <div className='dropdown-item h-100'>
                      <form action=''>
                        <div className='form-group'>
                          <label htmlFor=''>Sort List</label>
                          <select
                            id=''
                            className='form-control'
                            onChange={(e: any) => {
                              setSortOrder(e.target.value)
                            }}
                          >
                            <option value='DESC'>Descending Order</option>
                            <option value='ASC'>Ascending Order</option>
                          </select>
                        </div>
                        <div className='form-group mt-3'>
                          <label htmlFor=''>Status</label>
                          <select
                            id=''
                            value={status || ''}
                            className='form-control'
                            onChange={(e: any) => {
                              setStatus(e.target.value || undefined)
                            }}
                          >
                            <option disabled value=''>
                              ---select---
                            </option>
                            <option value='PENDING_APPROVAL'>Pending Approval</option>
                            <option value='APPROVED'>Approved</option>
                            <option value='REJECTED'>Rejected</option>
                            <option value='ON_GOING'>On Going</option>
                            <option value='COMPLETED'>Completed</option>
                          </select>
                        </div>
                        <div className='form-group mt-3 d-none'>
                          <label htmlFor=''>Hr Status</label>
                          <select
                            id=''
                            value={hrApprovalStatus || ''}
                            className='form-control'
                            onChange={(e: any) => {
                              setHrApprovalStatus(e.target.value || undefined)
                            }}
                          >
                            <option disabled value=''>
                              ---select---
                            </option>
                            <option value='PENDING_HR_APPROVAL'>Pending Hr Approval</option>
                            <option value='APPROVED'>Approved</option>
                            <option value='REJECTED'>Rejected</option>
                          </select>
                        </div>
                        <div className='form-group mt-3'>
                          <label>Leave Date</label>

                          <div className='row'>
                            <div className='col-6'>
                              <label className='small text-muted'>From</label>
                              <input
                                type='date'
                                className='form-control'
                                {...register('leaveDateFrom')}
                              />
                            </div>

                            <div className='col-6'>
                              <label className='small text-muted'>To</label>
                              <input
                                type='date'
                                className='form-control'
                                {...register('leaveDateTo')}
                              />
                            </div>
                          </div>
                        </div>

                        <div className='row mt-3'>
                          <div className='col-md-6'>
                            <button
                              disabled={!empty}
                              onClick={handleReset}
                              className='btn btn-reset'
                            >
                              Reset
                            </button>
                          </div>
                          <div className='col-md-6 text-end d-none'>
                            <button className='btn btn-filter'>Filter</button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className='col-6 col-md-2 dropdown'>
                  <button
                    className='btn btn-export dropdown-toggle'
                    data-bs-toggle='dropdown'
                    aria-expanded='false'
                    disabled
                  >
                    <DownloadSvg />
                    Export
                  </button>

                  <ul className='dropdown-menu dropdown-menu-end export-dropdown border-0 shadow'>
                    <li className='dropdown-item'> Export as .pdf</li>
                    <li className='dropdown-item'> Export as .xlsx</li>
                    <li className='dropdown-item'> Export as .doc </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className='card-body'>
              <div className='table-responsive'>
                <table className='table'>
                  <thead>
                    <tr>
                      <td>#</td>
                      <td>Employee</td>
                      <td>Leave Type</td>
                      <td>Start Date</td>
                      <td>End Date</td>
                      <td>Duration</td>
                      <td>Reason</td>
                      <td>Status</td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    {leave &&
                      leave.map((data: leaveType, index: Key) => (
                        <tr key={index}>
                          <td>
                            {TableSerialNumber(
                              pageNumber,
                              paginationData.pageSize,
                              parseInt(index.toString()),
                            )}
                          </td>
                          <td>
                            {data.employee.firstName} {data.employee.lastName}
                          </td>
                          <td>{formatString(data.leaveType)}</td>
                          <td>{DateConverterWord(data.startDate)}</td>
                          <td>{DateConverterWord(data.endDate)}</td>
                          <td>{data.days} days</td>
                          <td>{data.reason}</td>
                          <td>
                            <span
                              className={`${
                                data.status === 'REJECTED'
                                  ? 'rejected'
                                  : data.status === 'PENDING_APPROVAL'
                                    ? 'pending'
                                    : ['APPROVED', 'COMPLETED'].includes(data.status)
                                      ? 'status'
                                      : ''
                              }`}
                            >
                              {data.status === 'PENDING_APPROVAL' &&
                              data.hrApprovalStatus === 'PENDING_HR_APPROVAL'
                                ? 'Pending HR Approval'
                                : data.status === 'PENDING_APPROVAL' &&
                                    data.hrApprovalStatus === 'APPROVED'
                                  ? 'Approved By HR'
                                  : data.status === 'APPROVED'
                                    ? 'Approved'
                                    : data.status === 'REJECTED'
                                      ? 'Rejected'
                                      : data.status}
                            </span>
                          </td>
                          <td className='dropdown option-dropdown'>
                            <button
                              className={`btn border-0 dropdown-toggle ${['REJECTED', 'APPROVED'].includes(data.status) ? 'disabled' : ''}`}
                              data-bs-toggle='dropdown'
                              aria-expanded='false'
                              data-bs-popper-config='{"strategy":"fixed"}'
                            >
                              <svg
                                width='18'
                                height='18'
                                viewBox='0 0 18 18'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <path
                                  d='M7.49991 8.4705C7.49991 7.72933 8.0955 7.14697 8.82344 7.14697C9.55138 7.14697 10.147 7.74256 10.147 8.4705C10.147 9.19844 9.55138 9.79403 8.82344 9.79403C8.0955 9.79403 7.49991 9.21168 7.49991 8.4705Z'
                                  fill='#707070'
                                />
                                <path
                                  d='M7.49991 14.1175C7.49991 13.3763 8.0955 12.7939 8.82344 12.7939C9.55138 12.7939 10.147 13.3895 10.147 14.1175C10.147 14.8454 9.55138 15.441 8.82344 15.441C8.0955 15.441 7.49991 14.8587 7.49991 14.1175Z'
                                  fill='#707070'
                                />
                                <path
                                  d='M7.49991 2.82353C7.49991 2.08235 8.0955 1.5 8.82344 1.5C9.55138 1.5 10.147 2.09559 10.147 2.82353C10.147 3.55147 9.55138 4.14706 8.82344 4.14706C8.0955 4.14706 7.49991 3.56471 7.49991 2.82353Z'
                                  fill='#707070'
                                />
                              </svg>
                            </button>

                            <ul className='dropdown-menu dropdown-menu-end export-dropdown border-0 shadow'>
                              {!isEmployeeExactlyAYearOrMoreThanAYear &&
                              isHr &&
                              data.hrApprovalStatus === 'PENDING_HR_APPROVAL' ? (
                                <li
                                  className='dropdown-item'
                                  onClick={() => leaveAction(data.id, 'approve')}
                                >
                                  Approve
                                </li>
                              ) : (
                                !isHr &&
                                data.hrApprovalStatus === 'APPROVED' && (
                                  <li
                                    className='dropdown-item'
                                    onClick={() => leaveAction(data.id, 'approve')}
                                  >
                                    Approve
                                  </li>
                                )
                              )}

                              {['PENDING_APPROVAL'].includes(data.status) && (
                                <li
                                  className='dropdown-item text-danger'
                                  onClick={() => leaveAction(data.id, 'reject')}
                                >
                                  Reject
                                </li>
                              )}
                            </ul>
                          </td>
                        </tr>
                      ))}

                    {loading === false && leave?.length === 0 && (
                      <tr>
                        <td colSpan={9} className='text-center'>
                          No leave found
                        </td>
                      </tr>
                    )}
                    {loading === true && leave?.length === 0 && (
                      <tr>
                        <td colSpan={9} className='text-center'>
                          <HorizontalLoader></HorizontalLoader>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {paginationData.total >= paginationData.pageSize && (
                <div className='pagination w-100 d-flex justify-content-center'>
                  {paginationData.total && (
                    <Pagination
                      className='pagination-bar ps-0'
                      currentPage={Number(paginationData.pageNumber)}
                      totalCount={paginationData.total}
                      pageSize={paginationData.pageSize}
                      onPageChange={(page: React.SetStateAction<number>) => setPageNumber(page)}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <ModalWrapper showModal={showModal} closeModal={toggleModal} title='Leave Application'>
        <LeaveForm toggle={() => toggleModal()}></LeaveForm>
      </ModalWrapper>
    </div>
  )
}

export default LeaveAdmin
